var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3406,
    height: 2369,
    viewBox: "0 0 3406 2369",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "6_113",
    d: "M1223.24 1375.9L1141.94 1254.09L1409.78 1082.04L1544.52 1288.74L1260.38 1473.1L1207.28 1387.26L1222.95 1377.29L1223.81 1376.75L1223.24 1375.9Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "6_112",
    d: "M1028.86 1074.62L898.529 875.981L1166.34 703.872L1295.29 901.649L1028.86 1074.62Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "6_107",
    d: "M848.278 908.381L976.06 1103.2L707.709 1276.64L581.526 1080.97L848.278 908.381Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "6_106",
    d: "M975.717 1103.33L1091.48 1288.33L825.053 1461.31L707.943 1276.3L975.717 1103.33Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "6_105",
    d: "M960.573 1668.37L825.19 1461.96L1091.8 1288.37L1178.24 1414.57L1178.79 1415.37L1179.61 1414.84L1192.77 1406.38L1243.69 1485.7L960.573 1668.37Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "6_104",
    d: "M1097.29 1882.64L966.958 1684L1234.77 1511.89L1363.72 1709.67L1097.29 1882.64Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "6_108",
    d: "M581.883 1081.18L452.71 884.32L719.782 711.391L848.313 908.206L581.883 1081.18Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "6_109",
    d: "M452.557 884.279L291.455 636.796L584.203 446.529L745.529 694.087L452.557 884.279Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "6_111",
    d: "M898.288 876.644L767.957 678.005L1035.78 505.892L1166.18 703.209L898.288 876.644Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "6_110",
    d: "M874.774 257.385L1035.59 505.628L746.449 694.121L584.14 446.426L874.774 257.385Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "6_96",
    d: "M1678.07 1416.5V1315H1744.7H1907.57V1637H1802.66H1667.57V1548V1547H1666.57H1651.07V1417.5H1677.07H1678.07V1416.5Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "6_97",
    d: "M2044.7 1637H1907.57V1315H1992.23H2139.57V1637H2044.7Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "6_98",
    d: "M2282.01 1637H2139.57V1315H2227.52H2380.57V1637H2282.01Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "6_99",
    d: "M2282.01 2020H2139.57V1698H2227.52H2380.57V2020H2282.01Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "6_100",
    d: "M2044.7 2020H1907.57V1698H1992.23H2139.57V2020H2044.7Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "6_101",
    d: "M1812.7 2020H1675.57V1698H1760.23H1907.57V2020H1812.7Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "6_102",
    d: "M1580.7 2020H1443.57V1698H1528.23H1675.57V2020H1580.7Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "6_103",
    d: "M1187.11 2020L1097.96 1885.29L1309.11 1749.84L1309.86 1749.36L1309.46 1748.55L1301.43 1732.48L1377.28 1698H1443.57V2020H1348.7H1187.11Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor6);
export default __webpack_public_path__ + "static/media/select_floor_6.74c413d7902c69952194f36ebeb59254.svg";
export { ForwardRef as ReactComponent };